<template>
  <el-dialog
    :title="$t('partnerPool.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div class="text-center">
      <p>{{ $t('partnerPool.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('partnerPool.cancel') }}</el-button>
      <el-button type="primary" @click="deletePartnerPool">
        {{ $t('partnerPool.confirmDeleteBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deletePartnerPool } from '@/api/partner/partnerApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeletePartnerPool',
  data() {
    return {
      dialogVisible: false,
      deletePartnerPoolInfo: {}
    }
  },
  methods: {
    open(partnerPool) {
      this.deletePartnerPoolInfo = { ...partnerPool }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deletePartnerPoolInfo = {}
    },
    async deletePartnerPool() {
      this.deletePartnerPoolInfo.shopId = getShopId()
      
      try {
        const res = await deletePartnerPool(this.deletePartnerPoolInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('partnerPool.deleteSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('partnerPool.deleteFailed'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>